import(/* webpackMode: "eager", webpackExports: ["ClockHands"] */ "/home/runner/work/next-yak/next-yak/examples/next-js/app/ClockHands.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HighContrastToggle"] */ "/home/runner/work/next-yak/next-yak/examples/next-js/app/HighContrastToggle.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/next-yak/next-yak/examples/next-js/app/page.module.css");
;
import(/* webpackMode: "eager" */ "/home/runner/work/next-yak/next-yak/examples/next-js/app/Clock.tsx?./Clock.yak.module.css");
;
import(/* webpackMode: "eager" */ "/home/runner/work/next-yak/next-yak/examples/next-js/app/Input.tsx?./Input.yak.module.css");
;
import(/* webpackMode: "eager" */ "/home/runner/work/next-yak/next-yak/examples/next-js/app/page.tsx?./page.yak.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["YakThemeProvider"] */ "/home/runner/work/next-yak/next-yak/packages/next-yak/dist/context/index.js");
